import React from "react";

interface IRouteData {
  calcTime: string;
  carNum: string;
  pointStatus: string;
}

export const RouteData = ({ calcTime, carNum, pointStatus }: IRouteData) => {
  function takeTimeFromDate(date: string) {
    const newDate = new Date(date);
    const minutes = newDate.getMinutes() < 10 ? `0${newDate.getMinutes()}` : newDate.getMinutes()
    const correctTime = `${newDate.getHours()}:${minutes}`;
    console.log(newDate.getMinutes());
    return correctTime;
  }

  const timeName = {
    time: pointStatus === "Собрано" ? "Время сбора:" : "Расчетное время:",
    calc:
      pointStatus === "Собрано"
        ? `Сбор завершен в ${takeTimeFromDate(calcTime)}`
        : `Машина приедет в ${takeTimeFromDate(calcTime)}`
  };
  return (
    <div className="route-panel__car-time">
      <div className="car-time__container">
        <p className="car-time__calc">{timeName.time}</p>
        <p className="car-time__time">{timeName.calc}</p>
      </div>
      <div className="car-time__container">
        <p className="car-time__calc">Номер машины:</p>
        <p className="car-time__car">{carNum.toLowerCase()}</p>
      </div>
    </div>
  );
};
